export default {
  language: '语言',
  contactUs: '联系我们',
  officialWebsite: 'TokenPocket官网',
  twitter: '推特',
  telegram: 'Telegram',
  connectWallet: '连接钱包',
  connectTPWallet: '1. 连接TokenPocket',
  addZetaChain: '2. 自定义添加ZetaChain测试网',
  ZETAAmount: '3. 领取ZetaChain测试币:',
  start: '开始',
  verify: '验证',
  Verified: '已验证',
  tutorial: '教程',
  more: '更多',
  close: '收起',
  discoverMore: '在#TokenPocketChristmas探索更多惊喜',
  getTestnetZETA: '领取 $ZETA 测试币',
  switchWallet: '请先在钱包切换到EVM钱包',
  modal: {
    title: '连接TokenPocket',
    desc: '您的Web3钱包',
    text_1: '安装TokenPocket插件到Chrome浏览器。',
    text_2: '下载TokenPocket移动端钱包。',
    text_3: '手机扫描二维码进入TokenPocket官网下载。',
    text_4: 'INJECTED',
  },
  
  activity_text_1: '1. 完成社交任务',
  activity_text_2: '根据Galxe指引完成社交任务。',
  activity_1_1: 'TokenPocket',
  activity_1_2:
    'TokenPocket是全球领先的多链自托管钱包，支持BTC、ETH、BSC、TRON、DOGE、ZetaChain、Polygon、Arbitrum, Optimism, Solana、HECO、Klaytn、Avalanche、Fantom、Polkadot、Kusama等主流公链。',

  activity_2_1: 'ZetaSwap',
  activity_2_2:
    'ZetaSwap 是 ZetaChain 上第一个原生支持的PMM，让用户可以轻松高效地在 ZetaChain 网络上兑换资产。 ZetaSwap 确保您在使用 ZetaChain 时获得深度流动性、最便宜的成本和用户友好的体验。',
  activity_2_5: '2. 在ZetaSwap上交易。',
  activity_2_6: '体验zetaETH兑换zetaBTC或zetaBTC兑换zetaETH。',

  activity_3_1: 'Eddy Finance',
  activity_3_2:
    'Eddy Finance是基于ZetaChain的全链去中心化交易所（DEX），通过无与伦比的速度和成本效益简化了跨网络的原生资产转移，而无需进行任何包装。Eddy的跨链统一流动性池结合了包括ETH、BTC、BNB和稳定币在内的原生资产，以优化效率。Eddy通过将BTC无缝整合到以太坊虚拟机（EVM）生态系统中，进一步增强了BTC，在DeFi领域开启了新的视野。',
  activity_3_5: '2. 在Eddy Finance上交易。',
  activity_3_6: '在Eddy Finance交易任意两个代币。',

  activity_4_1: 'LENX',
  activity_4_2:
    'LENX是专注于比特币的借贷协议。通过利用经过时间验证的协议，如Aave和Compound，您可以存款和借贷资产，以获得最佳利率。',
  activity_4_5: '2. 在Discord领取测试网代币。',
  activity_4_6: '你可以在LENX的Discord上领取测试网上的BTC和ETH。',
  activity_4_7: '3. 体验全链资产借入/存款服务。',
  activity_4_8: '在LENX借出任意数量的BTC测试币后，存入ETH。',

  activity_5_1: 'zkMe',
  activity_5_2:
    'zkMe 是一个去中心化 Web3 凭证网络，利用零知识证明、多方安全计算及机器学习技术来增强去中心化身份的隐私和安全。',
  activity_5_5: '2. 铸造专属Omni NFT。',
  activity_5_6: '在zkMe上绘制圣诞标志并铸造专属Omni NFT。',

  activity_6_1: 'Ultiverse ',
  activity_6_2:
    'Ultiverse的目标是将MetaFi变为现实，并创建一个提供用户多种不同体验的Web3游戏和元宇宙平台。他们利用MetaFi和先进的去中心化应用程序（Dapps）来建立一个包容所有人的社区。凭借超过2,000万美元的资金，Ultiverse的生态系统是一个充满活力和互动性的地方，激发人们的创造力并勇于探索。',
  activity_6_5: '2. 铸造一个 Meta Merge Match 3 NFT。',
  activity_6_6: '赢得第一轮游戏的胜利并铸造你的 Meta Merge Match 3 NFT。',

  activity_7_1: 'Sushi',
  activity_7_2:
    'Sushi是一家领先的多链去中心化交易所（DEX），部署在30多条链上，并通过SushiXSwap提供独特的跨链交换服务。专注于提供无缝的用户体验、创新的交易和增强的流动性提供，Sushi致力于成为一个由社区构建、开源的DeFi工具生态系统，涵盖您所需的所有工具。',

  activity_8_1: 'Suger',
  activity_8_2: '一个Web3约会应用程序，提升人与人之间的连接，不仅仅是浪漫。',
  activity_8_5: '2. 领取免费Suger Pass卡。',
  activity_8_6: '在Suger上领取Suger Pass卡并加入Suger白名单。。',

  activity_9_1: 'ChatGM',
  activity_9_2: 'ChatGM使用交互式AI使web3简单易用。ChatGM将EVM/BTC钱包作为数字id，提供跨加密钱包、Telegram、WhatsApp的加密短信、语音、视频通话',
  activity_9_5: '2. 访问ChatGM官网并注册一个ChatGM账号。',
  activity_9_6: '访问ChatGM官网并提供邮箱/钱包注册一个ChatGM账号来获得未来的空投和积分。',
  activity_9_7: '3. 领取POAP。',
  activity_9_8: '在Galxe铸造你的OAT，该OAT将作为ChatGM的 OG POAP。',

  activity_10_1: 'CharacterX',
  activity_10_2: 'CharacterX是一个分散的合成社交网络，用户和人工智能代理可以在其中进行交互、创建、投资和赚钱。它旨在通过创新的人工智能NFT机制，为创造者、消费者、人工智能代理和投资者提供可持续的经济。先进的多模式技术，包括语音、视觉和3D AR，大大增加了用户体验。',
  activity_10_5: '2.创建AI角色并铸造NFT。',
  activity_10_6: '创建你自己的 AI 角色并铸造Soul Pass NFT。',
};
